import { Button, ButtonProps, Icon } from '@chakra-ui/react';
import { ComponentProps } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { HiMiniArrowLeft, HiMiniArrowRight } from 'react-icons/hi2';
import { SmartLink } from './smart-link';

export type NavButtonDirection = 'forward' | 'fwd' | 'backward' | 'bk' | 'none' | 'up-right' | 'ur' | undefined;
type CustomNavButtonProps = {
  target?: string;
  direction?: NavButtonDirection;
  href: string;
  arrowSize?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  w?: any;
} & ButtonProps;

export type NavButtonProps = ButtonProps &
  CustomNavButtonProps & { linkProps?: Partial<ComponentProps<typeof SmartLink>> };

const fwdDirections = new Set(['forward', 'fwd']);
const bkDirections = new Set(['backward', 'bk']);
const upRightDirections = new Set(['up-right', 'ur']);
export const NavButton = ({
  direction = 'none',
  href,
  children,
  arrowSize,
  w = 'auto',
  variant = 'outline',
  linkProps,
  ...rest
}: NavButtonProps) => {
  const outlineStyles = variant === 'outline' || !variant ? { bg: 'bg', _hover: { bg: 'bg.muted' } } : {};
  return (
    <SmartLink href={href} w={w} {...linkProps}>
      <Button borderRadius={'3xl'} px={3} gap={1} w={w} variant={variant} {...outlineStyles} {...rest}>
        {bkDirections.has(direction) && (
          <Icon boxSize={arrowSize ?? 4}>
            <HiMiniArrowLeft />
          </Icon>
        )}
        {children}
        {upRightDirections.has(direction) && (
          <Icon boxSize={arrowSize ?? 4}>
            <FiArrowUpRight />
          </Icon>
        )}
        {fwdDirections.has(direction) && (
          <Icon boxSize={arrowSize ?? 4}>
            <HiMiniArrowRight />
          </Icon>
        )}
      </Button>
    </SmartLink>
  );
};
